import SiteIcon from "./SiteIcon";
import "./VmLanding.css";

export default function VmLanding() {
    // <SiteIcon name="Example Site" url="https://example.com" icon="https://en.wikipedia.org/favicon.ico"/>
    const sites:{name:string,url:string,icon?:string,color?:string}[] = [
        {name: "DuckDuckGo", url: "https://duckduckgo.com/", icon: "https://duckduckgo.com/favicon.ico",color:"#E37151"},
        {name: "Wikipedia", url: "https://www.wikipedia.org/", icon: "https://en.wikipedia.org/favicon.ico", color:"lightgrey"},
        {name: "Twitch", url: "https://www.twitch.tv/", icon: "https://twitch.tv/favicon.ico", color:"#6441a5"},
        //{name: "BBB", url: "https://download.blender.org/peach/bigbuckbunny_movies/big_buck_bunny_1080p_h264.mov", color:"#008000"},
        {name: "Youtube (Invid)", url: "https://inv.nadeko.net/feed/popular", color:"#FF0000",icon:"https://avatars.githubusercontent.com/u/68407447?s=200&v=4"},
    ];
    return (
    <div className="vm-landing">
        <h1>Welcome to Browse.Party</h1>
        <div className="siteSelection">
            {sites.map((site, index) => (
            <SiteIcon key={index} name={site.name} url={site.url} icon={site.icon} color={site.color} />
            ))}
        </div>
    </div>
    );
}